import { Box } from '@mui/material';
import { Allotment } from 'allotment';
import 'allotment/dist/style.css';
import clsx from 'clsx';
import { useState } from 'react';
import GripLinesVertIcon from '../icons/GripLinesVertIcon';
import { LayoutLeftPane } from './coding-tab-contents/LayoutLeftPane';
import { LayoutRightPane } from './coding-tab-contents/LayoutRightPane';

interface Props {
  className?: string;
}

export function CodingTabContent(props: Props) {
  const { className } = props;
  const [dragging, setDragging] = useState(false);
  const [draggingLeft, setDraggingLeft] = useState<number>();

  return (
    <Box className={clsx(className, 'CodingTabContent-root')} sx={{ position: 'relative' }}>
      <Box
        component={Allotment}
        separator={false}
        sx={{
          '& .LayoutLeftPane-root': {
            pr: '8px',
          },
          '& .LayoutRightPane-root': {
            pl: '8px',
            '& > *:first-of-type': {
              borderLeft: '1px solid #eee',
            },
          },
        }}
        onDragStart={() => {
          setDragging(true);
        }}
        onChange={(sizes) => {
          setDraggingLeft(sizes[0]);
        }}
        onDragEnd={(sizes) => {
          setDraggingLeft(sizes[0]);
          setDragging(false);
        }}
      >
        <Allotment.Pane minSize={200}>
          <LayoutLeftPane sx={{ flex: 1 }} />
        </Allotment.Pane>
        <Allotment.Pane minSize={100}>
          <LayoutRightPane />
        </Allotment.Pane>
      </Box>

      {typeof draggingLeft === 'number' && (
        <Box
          sx={{
            position: 'absolute',
            left: draggingLeft,
            top: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 0,
            color: (theme) => (dragging ? theme.palette.primary.main : '#bbb'),
            '& svg': {
              pointerEvents: 'none',
              width: 12,
              height: 16,
            },
          }}
        >
          <GripLinesVertIcon />
        </Box>
      )}
    </Box>
  );
}
